import { resourcesSubscriber } from '@/mqtt/resources'
import SlideApi from '@/api/slide'
import util from '@/util'

const setPresentationAction = (context, payload) => {
  context.commit('setPresentation', payload)
}

const patchPresentationAction = (context, payload) => {
  context.commit('patchPresentation', payload)
}

const setActiveTabAction = (store, payload) => {
  store.commit('setActiveTab', payload.activeTab || payload)
}

const subscribeSlideChangeAction = ({ dispatch, commit, getters }, payload) => {
  resourcesSubscriber.subscribeResourceUri(`/LIVE_SESSION/${payload.id}/ACTIVE_ACTIVITY`, async (message) => {
    const msg = JSON.parse(message)
    const slideId = msg.activeActivityId
    if (!slideId) return
    if (getters['featureToggles/canUseNewChangeSlideMechanism']) {
      commit('updateSlideV2', {
        id: slideId,
        slideTimestamp: msg.slideTimestamp,
      })
    }

    const slide = await SlideApi.getSlideDetailV2(slideId)
    slide.slideTimestamp = msg.slideTimestamp

    if (!slide.id) return

    // TODO: find a way to avoid setting an empty slide before setting the actual slide. This is a tech debt that existed long before.
    dispatch('setSlideV2Action', { id: null })

    setImmediate(() => {
      dispatch('setSlideV2Action', {
        ...util.formatSlide(slide),
        receiveTimestamp: new Date().getTime(),
      })
    }, 0)
  }, { once: true })
}

const unsubscribeSlideChangeAction = (_, payload) => {
  resourcesSubscriber.unsubscribeResourceUri(`/LIVE_SESSION/${payload.id}/ACTIVE_ACTIVITY`)
}

export default {
  setPresentationAction,
  setPresentation: setPresentationAction,
  patchPresentationAction,
  setActiveTabAction,
  subscribeSlideChangeAction,
  unsubscribeSlideChangeAction,
}
